(function () {
  'use strict';

  if (window.CustoGiftsProductPersonalization) {
    window.CustoGiftsProductPersonalization.initialize(document);
    return;
  }

  var instances = new WeakMap();

  class CustoProductPersonalization {
    constructor(root) {
      this.root = root;
      this.toggle = root.querySelector('[data-personalization-toggle]');
      this.fields = root.querySelector('[data-personalization-fields]');
      this.adapter = root.querySelector('[data-cg-personalization-adapter]');
      this.onChange = this.onChange.bind(this);
      if (this.toggle) {
        this.toggle.addEventListener('change', this.onChange);
        root.dataset.personalizationEnhanced = 'true';
        this.sync();
      } else {
        this.setFieldsEnabled(true);
      }
    }

    onChange() {
      this.sync();
    }

    sync() {
      var isEnabled = Boolean(this.toggle?.checked);
      this.toggle?.setAttribute('aria-expanded', String(isEnabled));
      if (this.fields) this.fields.hidden = !isEnabled;
      this.setFieldsEnabled(isEnabled);
      this.root.dispatchEvent(new CustomEvent('custogifts:personalization:toggle', {
        bubbles: true,
        detail: { enabled: isEnabled },
      }));
    }

    setFieldsEnabled(isEnabled) {
      this.root.querySelectorAll('[data-personalization-field]').forEach(function (field) {
        field.disabled = !isEnabled;
        field.required = isEnabled && field.dataset.requiredWhenPersonalizing === 'true';
        field.setAttribute('aria-disabled', String(!isEnabled));
      });
      if (this.adapter) this.adapter.dataset.personalizationEnabled = String(isEnabled);
    }
  }

  function initialize(scope) {
    var roots = [];
    if (scope instanceof Element && scope.matches('[data-cg-product-personalization]')) roots.push(scope);
    scope.querySelectorAll?.('[data-cg-product-personalization]').forEach(function (root) { roots.push(root); });
    roots.forEach(function (root) {
      if (instances.has(root)) return;
      instances.set(root, new CustoProductPersonalization(root));
    });
  }

  window.CustoGiftsProductPersonalization = Object.freeze({ initialize: initialize });
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('change', function (event) {
    var variantSelect = event.target.closest('[data-variant-select]');
    if (!variantSelect) return;
    var productSection = variantSelect.closest('[data-section-id]');
    productSection?.querySelectorAll('[data-cg-personalization-adapter]').forEach(function (adapter) {
      adapter.dataset.variantId = variantSelect.value;
    });
  });
})();
